import { CODE, TRANSFORMERS, Transformer } from '@lexical/markdown';
import { LexicalEditor } from 'lexical';
import { createCodePassthroughTransformer } from './code-passthrough';
import { createHtmlTransformer } from './html';
import { BR } from './html/br';
import { createInlineTableTransformer } from './html/inline-table';
import { createTableTransformer as createHtmlTableTransformer } from './html/table';
import { IMAGE } from './image';
import {
  createInlineSuggestionTransformer,
  createSuggestionMarkExportTransformer,
} from './inline-suggestions';
import { PAGE_BREAK } from './pagebreak';
import { createSuggestionTransformer } from './suggestion';
import { createTableTransformer as createMarkdownTableTransformer } from './table';

function createBaseTransformers(editor: LexicalEditor) {
  const htmlTransformer = createHtmlTransformer(editor);
  const htmlTableTransformer = createHtmlTableTransformer(editor);
  const inlineTableTransformer = createInlineTableTransformer(editor);

  return [
    ...TRANSFORMERS.filter(t => t !== CODE),
    BR,
    IMAGE,
    PAGE_BREAK,
    htmlTransformer,
    htmlTableTransformer,
    inlineTableTransformer,
  ];
}

export const createCopyTransformers = (editor: LexicalEditor): Transformer[] => {
  const base = createBaseTransformers(editor);
  const allTransformers: Transformer[] = [];
  const getTransformers = () => allTransformers;
  const markdownTableTransformer = createMarkdownTableTransformer(getTransformers);
  allTransformers.push(markdownTableTransformer, ...base);
  return allTransformers;
};

export const createTransformers = (editor: LexicalEditor): Transformer[] => {
  const base = createBaseTransformers(editor);

  const allTransformers: Transformer[] = [];
  const getTransformers = () => allTransformers;

  const markdownTableTransformer = createMarkdownTableTransformer(getTransformers);
  const innerTransformers = [...base, markdownTableTransformer];
  const codePassthroughTransformer = createCodePassthroughTransformer(innerTransformers);
  const inlineSuggestionTransformer = createInlineSuggestionTransformer(innerTransformers);
  const suggestionMarkExportTransformer = createSuggestionMarkExportTransformer();
  const suggestionTransformer = createSuggestionTransformer(innerTransformers);

  // inlineSuggestionTransformer must come before other transformers to ensure
  // the regex suggestion matches correctly.
  // markdownTableTransformer handles markdown-origin tables
  // htmlTableTransformer handles HTML-origin tables (multiline-element type)
  // inlineTableTransformer handles HTML-origin tables when nested (text-match type)
  allTransformers.push(
    suggestionTransformer,
    suggestionMarkExportTransformer,
    inlineSuggestionTransformer,
    markdownTableTransformer,
    codePassthroughTransformer,
    ...base,
  );

  return allTransformers;
};
